import DietaryIcons from '../../../components/DietaryIcons';
import { useSelector } from 'react-redux';
import CustomiseCardRequiredRadio from './CustomiseCardRequiredRadio';
import { Tags } from '../../../components/Tags';
import { getPeppers } from './CustomiseCard';

const CustomiseCardBase = ({
  name,
  selected,
  selectedQuickAddOption,
  cost,
  parent,
  option,
  isPeppers,
  disabled,
  calories,
  showCalories,
  currentTier,
  loyaltySchemeVersion,
  isDuoRomana,
  handleBaseNameClick,
  handleChoiceModalEdit
}) => {
  const { isTabletScreen } = useSelector(state => state.session);

  const getPrice = () => {
    return (
      <>
        {
          cost && !isPeppers ?
            <p className='customise-card-price' data-testid='customise-card-info-price' style={{ opacity: disabled ? 0.5 : 1 }}>{cost?.toFixed(2)}</p>
            :
            null
        }
        {
          option.upliftPrice &&
          <p className='customise-card-price' data-testid='customise-card-info-uplift-price' style={{ opacity: disabled ? 0.5 : 1 }}>{option.upliftPrice.toFixed(2)}</p>
        }
      </>
    );
  }

  const CustomiseCardBaseWithSelectedQuickAddOption = () => {
    return (
      <>
        <div className='customise-card-info-container'>
          <CustomiseCardRequiredRadio
            selected={selected}
            parent={parent} />
          <div className={'customise-card-info-and-edit'}>
            <div className={'customise-card-info-and-tag'}>
              <div className={'customise-card-info-and-quick-add'}>
                <div className='customise-card-info'>
                  <p className={`customise-card-info-name ${(isDuoRomana && option.imageUrl) ? 'isDuoRomana' : ''}`}
                    data-testid='customise-card-info-name'
                    style={{ opacity: disabled ? 0.5 : 1 }}
                    onClick={(e) => handleBaseNameClick && handleBaseNameClick(e, option)}>
                    {name}
                  </p>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    {
                      showCalories && calories ?
                        <p role='calories' style={{ opacity: 0.8 }} className='customise-card-info-calories' data-testid='customise-card-info-calories'>
                          {`(${calories})`}
                        </p>
                        :
                        null
                    }
                    {
                      (option.product?.dietPreferences || option.dietPreferences) &&
                      <>
                        <DietaryIcons icons={option.product?.dietPreferences || option.dietPreferences} style={{ margin: 0 }} iconSize={20} />
                        {
                          getPeppers(option.uiTags)
                        }
                      </>
                    }
                  </span>
                  {isTabletScreen &&
                    getPrice()
                  }
                </div>
                <p style={{ color: '#6D6D6D' }}>{selectedQuickAddOption?.selected?.name}</p>
              </div>
              <Tags
                currentTier={currentTier}
                loyaltySchemeVersion={loyaltySchemeVersion}
                excludeChildTags={true}
                showLocked={false}
                item={option}
                wrapperClass={'all-tags-wrapper'}
                outOfStockDisabled
              />
            </div>
            <p className={`customise-card-info-name ${(isDuoRomana && option.imageUrl) ? 'isDuoRomana' : ''}`}
              data-testid='customise-card-info-name'
              style={{ opacity: disabled ? 0.5 : 1 }}
              onClick={(e) => handleChoiceModalEdit(e, option)}>
              Edit
            </p>
          </div>
        </div>
        {!isTabletScreen &&
          getPrice()
        }
      </>
    )
  }

  return (
    <>
      {selectedQuickAddOption?.id === option.id && selectedQuickAddOption.selected ?
        <CustomiseCardBaseWithSelectedQuickAddOption />
        :
        <div className='customise-card-info-container'>
          <CustomiseCardRequiredRadio
            selected={selected}
            parent={parent} />
          <div className={'customise-card-info-and-tag'}>
            <div className='customise-card-info'>
              <p className={`customise-card-info-name ${(isDuoRomana && option.imageUrl) ? 'isDuoRomana' : ''}`}
                data-testid='customise-card-info-name'
                style={{ opacity: disabled ? 0.5 : 1 }}
                onClick={(e) => handleBaseNameClick && handleBaseNameClick(e, option)}>
                {name}
              </p>
              <span style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                {
                  showCalories && calories ?
                    <p role='calories' style={{ opacity: 0.8 }} className='customise-card-info-calories' data-testid='customise-card-info-calories'>
                      {`(${calories})`}
                    </p>
                    :
                    null
                }
                {
                  (option.product?.dietPreferences || option.dietPreferences) &&
                  <>
                    <DietaryIcons icons={option.product?.dietPreferences || option.dietPreferences} style={{ margin: 0 }} iconSize={20} />
                    {
                      getPeppers(option.uiTags)
                    }
                  </>
                }
              </span>
              {isTabletScreen &&
                getPrice()
              }
            </div>
            <Tags
              currentTier={currentTier}
              loyaltySchemeVersion={loyaltySchemeVersion}
              excludeChildTags={true}
              showLocked={false}
              item={option}
              wrapperClass={'all-tags-wrapper'}
              outOfStockDisabled
            />
          </div>
        </div>
      }
      {!isTabletScreen &&
        getPrice()
      }
    </>
  );
};

export default CustomiseCardBase;